module.exports = __webpack_public_path__ + "static/media/alerm.26bcab9a.wav";